import { BsFillCircleFill } from "react-icons/bs";
import * as Component from "..";
import ari from "../../Assets/images/ari.webp";
import profile from "../../Assets/images/profile.png";
import js from "../../Assets/images/js.png";
import rc from "../../Assets/images/react.png";
import fg from "../../Assets/images/figma.png";
import ps from "../../Assets/images/ps.png";
import ci from "../../Assets/images/ci.png";
import mysql from "../../Assets/images/mysql.png";
import php from "../../Assets/images/php.png";
import { useDispatch, useSelector } from "react-redux";
import { setColor } from "../../Bootstraps/actions";
import classNames from "classnames";
import Colors from "../../Styles/Colors/Colors.module.css";
import AOS from "aos";
import "aos/dist/aos.css";
import "../../Styles/animation.css";
import { useEffect } from "react";

function Banner() {
  const dispatch = useDispatch();
  const { blue, red, purple, green, datas } = useSelector((state) => state.data);
  // console.log(datas)

  // console.log(blue)
  const blueHandling = () => {
    dispatch(setColor({ blue: true, green: false, red: false, purple: false, datas: datas }));
  };
  // console.log(red)
  const redHandling = () => {
    dispatch(setColor({ red: true, purple: false, green: false, blue: false, datas: datas }));
  };
  // console.log(purple)
  const purpleHandling = () => {
    dispatch(setColor({ purple: true, red: false, green: false, blue: false, datas: datas }));
  };
  // console.log(green)
  const greenHandling = () => {
    dispatch(setColor({ green: true, red: false, purple: false, blue: false, datas: datas }));
  };

  useEffect(() => {
    AOS.init({
      once: true,
    });
  }, []);

  return (
    <div className="h-full lg:h-screen lg:overflow-y-hidden">
      <div className="flex flex-col-reverse overflow-y-hidden lg:flex-row">
        {/* Left Side */}
        <div className="container px-5 lg:px-16 pt-10 lg:pt-40 max-w-full lg:w-2/4 h-screen text-gray-800 bg-[#F6F7FF] overflow-y-hidden">
          <div className="container flex items-center justify-center m-auto lg:justify-start max-3xl lg:m-0">
            <h1 className="font-extrabold text-8xl" data-aos="fade-right" data-aos-duration="2000">
              I'M
            </h1>
            <div className="flex flex-col items-start justify-between px-8 text-3xl font-bold">
              <p data-aos="fade-down" data-aos-duration="2000">
                Ari Pramana
              </p>
              <p className={classNames("text-xl lg:text-4xl", blue === true ? Colors.blue : red === true ? Colors.red : purple === true ? Colors.purple : green === true ? Colors.green : "")}>Programmer</p>
            </div>
          </div>

          <p className="max-w-md m-auto mt-10 font-semibold text-gray-400 sm:text-center lg:text-start lg:m-1 lg:mt-10">Impian tidak dapat terwujud dengan sendirinya, akan tetapi impian akan datang ketika kita berusaha untuk meraihnya.</p>

          {/* Button */}
          <div className="flex mt-10 sm:justify-center lg:justify-start">
            <Component.Button btn="hireMe" className={classNames("text-xs", blue === true ? Colors.blueBtn : red === true ? Colors.redBtn : purple === true ? Colors.purpleBtn : green === true ? Colors.greenBtn : "")} />

            {/* ICON */}
            <Component.IconsSosmed className="flex pl-10" aClassName="text-4xl ml-6" />
          </div>

          {/* Statistik */}
          <div className="flex max-w-md text-2xl font-bold mt-14 sm:m-auto sm:mt-20 lg:m-0 lg:mt-20">
            <p className="">+10 Project Done</p>
            <p className="pl-8">+22 Mini Project</p>
          </div>

          {/* Change Color */}
          <div className="flex items-center mt-20 sm:justify-center lg:justify-start">
            <p className={classNames("text-xl font-bold", blue === true ? Colors.blue : red === true ? Colors.red : purple === true ? Colors.purple : green === true ? Colors.green : "")}>Choose Color</p>
            <div className="flex items-center">
              <div
                onClick={() => {
                  blueHandling();
                }}
                className="ml-10 cursor-pointer"
              >
                <span className={classNames(Colors.blue, blue === true ? "text-5xl" : "text-4xl")}>
                  <BsFillCircleFill />
                </span>
              </div>

              <div
                onClick={() => {
                  redHandling();
                }}
                className="ml-10 cursor-pointer"
              >
                <span className={classNames(Colors.red, red === true ? "text-5xl" : "text-4xl")}>
                  <BsFillCircleFill />
                </span>
              </div>

              <div
                onClick={() => {
                  purpleHandling();
                }}
                className="ml-10 cursor-pointer"
              >
                <span className={classNames(Colors.purple, purple === true ? "text-5xl" : "text-4xl")}>
                  <BsFillCircleFill />
                </span>
              </div>

              <div
                onClick={() => {
                  greenHandling();
                }}
                className="ml-10 cursor-pointer"
              >
                <span className={classNames(Colors.green, green === true ? "text-5xl" : "text-4xl")}>
                  <BsFillCircleFill />
                </span>
              </div>
            </div>
          </div>

          <div className="relative bottom-0 mt-10 ">
            <svg
              className={classNames("fill-current", blue === true ? Colors.blue : red === true ? Colors.red : purple === true ? Colors.purple : green === true ? Colors.green : "")}
              stroke="currentColor"
              width="154"
              height="154"
              viewBox="0 0 154 154"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M154 77C154 119.526 119.526 154 77 154C34.4741 154 0 119.526 0 77C0 34.4741 34.4741 0 77 0C119.526 0 154 34.4741 154 77ZM27.8982 77C27.8982 104.118 49.8818 126.102 77 126.102C104.118 126.102 126.102 104.118 126.102 77C126.102 49.8818 104.118 27.8982 77 27.8982C49.8818 27.8982 27.8982 49.8818 27.8982 77Z" />
            </svg>
          </div>
        </div>

        {/* Right Side */}
        <div className="text-3xl pt-28 max-w-full lg:w-2/4 relative -z-10 h-[99vh] bg-gradient-to-b from-[#025381] to-[#7ACFFF]">
          <div className="flex">
            <marquee className="text-lg text-white" behavior="scroll" direction="left">
              AESTHETIC
              <span className="pl-24">KULIAH</span>
              <span className="pl-24">WEB DEVELOPMENT</span>
              <span className="pl-24">BALI</span>
              <span className="pl-24">GROWING</span>
              <span className="pl-24">23TH</span>
              <span className="pl-24">WONDERFUL</span>
            </marquee>
          </div>
          <img className="absolute right-20 top-60" src={js} alt="js" width="auto" height="100%" data-aos="zoom-in" data-aos-duration="300" />
          <img className="absolute top-40 left-20 animate-spin-slow" src={rc} alt="react" width="auto" height="100%" data-aos="zoom-in" data-aos-duration="600" />
          <img className="absolute bottom-60 left-10" src={fg} alt="figma" width="auto" height="100%" data-aos="zoom-in" data-aos-duration="900" />
          <img className="absolute bottom-40 right-12" src={ps} alt="photoshop" width="auto" height="100%" data-aos="zoom-in" data-aos-duration="1200" />
          <img className="absolute bottom-14 right-7 -z-10" src={mysql} alt="mysql" width="auto" height="50%" data-aos="zoom-in" data-aos-duration="600" />
          <img className="absolute z-10 bottom-20 left-5" src={php} alt="php" width="auto" height="80%" data-aos="zoom-in" data-aos-duration="1600" />
          {/* Image */}
          <div className="flex items-end justify-center">
            <img className="absolute bottom-0 -z-10" data-aos="fade-up" data-aos-offset="0" data-aos-duration="2500" src={profile} alt="ari" />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Banner;
